import type { WaveBlipRecord, WaveParticipantRecord } from "@vida/wave-core";
import { participantEmail } from "@vida/wave-core";
import { WaveAuthorAvatar } from "../presence/WaveAuthorAvatar";
import { WaveIdentityHoverTooltip } from "../presence/WaveIdentityHoverTooltip";
import { renderLinkifiedText } from "../../services/waveLinkify";

type Props = {
  blips: WaveBlipRecord[];
  blockAnchorId: string;
  participants?: WaveParticipantRecord[];
  draft: string;
  readOnly?: boolean;
  onDraftChange: (v: string) => void;
  onPost: () => void;
  onCollapse?: () => void;
};

export function WaveBlipThread({
  blips,
  blockAnchorId,
  participants = [],
  draft,
  readOnly = false,
  onDraftChange,
  onPost,
  onCollapse,
}: Props) {
  const thread = blips
    .filter((b) => b.blockAnchorId === blockAnchorId)
    .sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    );

  return (
    <div className="blip-thread" aria-label="Commenti legacy sul blocco">
      <div className="comment-thread-header">
        <span className="comment-thread-title">
          Commenti{thread.length > 0 ? ` (${thread.length})` : ""}
        </span>
        {onCollapse && (
          <button
            type="button"
            className="link-btn comment-collapse-btn"
            aria-label="Nascondi commenti"
            onClick={onCollapse}
          >
            Nascondi ▴
          </button>
        )}
      </div>
      {thread.length === 0 ? (
        <p className="blip-empty muted">Nessun commento ancora.</p>
      ) : (
        thread.map((b) => {
          const email = participantEmail(b.authorSub, participants);
          return (
            <WaveIdentityHoverTooltip
              key={b.blipId}
              dateIso={b.createdAt}
              email={email}
              className="blip-item"
            >
              <WaveAuthorAvatar authorSub={b.authorSub} participants={participants} />
              <p className="blip-body">{renderLinkifiedText(b.body)}</p>
            </WaveIdentityHoverTooltip>
          );
        })
      )}
      {!readOnly && (
        <div className="blip-compose">
          <input
            className="wave-title blip-compose-input"
            value={draft}
            placeholder="Scrivi un commento…"
            aria-label="Nuovo commento"
            onChange={(e) => onDraftChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                onPost();
              }
            }}
          />
          <button type="button" className="primary-btn blip-send-btn" onClick={onPost}>
            Invia
          </button>
        </div>
      )}
    </div>
  );
}
